import { useEffect, useState } from 'react';
import { Button, Switch, Dialog } from '../../tailwindcomponents';
import { Typography, LinearProgress, Input, Tabs } from '../../tailwindcomponents';
import SkillsApi from '../../api/skillsApi';
import { Skills } from '../../types/skills';
import { Dictionary } from '../../components';
import ManageSkills from './ManageSkills';
import Abbreviations from './Abbriviations';
import { useQueryTab } from '../../utils/usePersistedTab';

function MechanicInfo() {
    const [skill, setMechanicSkills] = useState<string>("");
    const [allSkills, setAllMechanicSkills] = useState<Skills[]>([]);
    const [showActive, setShowActive] = useState<boolean>(true);
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [skillsId, setSkillsId] = useState<number>(-1);
    const [valadiationText, setValidationText] = useState(false);
    const [reason, setReason] = useState<string>("");
    const { tabValue, setTabValue } = useQueryTab("tab", 0);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        refresh();
    }, []);

    const refresh = () => {
        setLoading(true);
        SkillsApi.GetSkills().then(res => {
            setAllMechanicSkills(res.data);
            setSkillsId(-1);
            setValidationText(false);
            setLoading(false);
        });
    }

    const addMechanicSkill = () => {
        setLoading(true);
        SkillsApi.CreateSkill(skill).then(res => {
            refresh();
            setLoading(false);
        });
    }

    const onOpenDeleteDialog = (row: Skills) => {
        setIsDialogOpen(true);
        setSkillsId(row.Id);
    }

    const onDeleteSkill = (status: boolean) => {
        if (status === true && skillsId > -1 && reason !== "" && !valadiationText) {
            setLoading(true);
            SkillsApi.DeleteSkill(reason, skillsId).then(res => {
                refresh();
                setIsDialogOpen(false);
                setLoading(false);
            });
        }
        else if (status === true && reason === "") {
            setValidationText(true);
        }
        else if (status === false) {
            setIsDialogOpen(false);
        }
    }

    const onInputChange = (text: string) => {
        setReason(text);
        if (text !== "") {
            setValidationText(false);
        }
    }

    return (
        <div>
            {loading === true &&
                <div>
                    <LinearProgress />
                </div>
            }
            <Tabs
                tabNames={["All skills", "Mechanic skills", "Abbreviations"]}
                onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
                tabValue={tabValue}
            />
            {(tabValue === 0) &&
                <div className="flex flex-wrap items-start justify-center w-full" >
                    <div className="w-1/2">
                        <div className="flex flex-wrap w-full">
                            <div className="w-1/3 lg:w-1/12">
                                <Typography text="Current" variant="subtitle2" color="textPrimary" margin={[2, 0, 0, 0]} />
                            </div>
                            <div className="w-1/6 lg:w-1/12">
                                <Switch
                                    checked={!showActive}
                                    onChange={() => setShowActive(!showActive)}
                                    color="secondary"
                                    name="checkedB"
                                />
                            </div>
                            <div className="w-1/6 lg:w-1/12" key={1}>
                                <Typography text="History" variant="subtitle2" color="textPrimary" margin={[2, 0, 0, 2]} />
                            </div>
                        </div>
                        <div className="w-5/6">
                            {
                                (allSkills !== undefined && allSkills.length > 0) && allSkills.filter(type => type.Visible === showActive).map((row, index) => (
                                    <Dictionary
                                        deleteProperty={(row: Skills) => onOpenDeleteDialog(row)}
                                        deleteButton={true}
                                        name={row.Skill}
                                        object={row}
                                        deleted={showActive === true ? false : true}
                                        id={row.Id}
                                    ></Dictionary>
                                ))
                            }
                        </div>
                    </div>
                    <div className="flex flex-wrap w-5/12">
                        <div className="w-full">
                            <br />
                            <Input
                                multiline={false}
                                label_text="Add Skill"
                                help_text="Please type in skill"
                                type="text"
                                value={skill}
                                width={50}
                                onTextChange={(value: string) => setMechanicSkills(value)}
                            />
                        </div>
                        <br />
                        <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addMechanicSkill()} >
                            Add Skill
                        </Button>
                    </div>
                </div>
            }
            {tabValue === 1 &&
                <ManageSkills allSkills={allSkills} loading={loading} setLoading={setLoading} />
            }
            {tabValue === 2 && 
                <Abbreviations loading={loading} setLoading={setLoading}/>
            }
            <Dialog
                visible={isDialogOpen}
                max_width={"sm"}
                title={"Delete skill"}
                context={
                    <div>
                        <Input
                            error={valadiationText}
                            multiline={true}
                            help_text={valadiationText ? "Reason can not be blank" : ""}
                            label_text={"Please provide a reason"}
                            value={reason}
                            onTextChange={(text: string) => onInputChange(text)}
                            type="text"
                            width={100}
                        />
                    </div>
                }
                onClose={(status: any) => onDeleteSkill(status)}
                strict={false}
                show_options={true}
            />
        </div>
    );
};
export default MechanicInfo;